import { post, get, postParams } from './http.js';


export const service = (data) => get('/service/cs.aspx', data);

export const Upload = (data) => post('/Upload.ashx', data);
